"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("./types");
const common_1 = require("../common");
const withEZSPM = (url, query) => {
    const { ezspm } = query;
    if (url && typeof ezspm !== "undefined") {
        let startChat = "?";
        if (url.includes("?")) {
            startChat = url.endsWith("&") ? "" : "&";
        }
        return `${url}${startChat}ezspm=${ezspm}`;
    }
    else {
        return url;
    }
};
const items = [
    [
        types_1.PageType.Web,
        {
            data2Http: (query) => {
                return withEZSPM(query.url, query);
            },
        },
    ],
    [
        types_1.PageType.Category,
        {
            httpReg: [/\/categories(?:\/(\d+))?/i, /\/category(?:\/(\d+))?((?!keyword).)*$/i],
            http2Data: (link, httpReg) => {
                const id = httpReg.exec(link)[1];
                const query = common_1.getUrlQuery(link);
                return {
                    id: id ? Number(id) : undefined,
                    ezspm: query.ezspm,
                };
            },
            data2Http: (query) => {
                if (!query.id) {
                    return withEZSPM(`/categories`, query);
                }
                return withEZSPM(`/category/${query.id}`, query);
            },
        },
    ],
    [
        types_1.PageType.Search,
        {
            httpReg: /\/category(?:\/(\d+))?\?.*keywords?=.*$/i,
            http2Data: (link) => {
                const query = common_1.getUrlQuery(link);
                return {
                    keyword: query.keyword || query.keywords,
                    ezspm: query.ezspm,
                };
            },
            data2Http: (query) => {
                const queryObj = {
                    keyword: query.keyword,
                };
                return withEZSPM(`/category${common_1.convertQueryToString(queryObj)}`, query);
            },
        },
    ],
    [
        types_1.PageType.ProductDetail,
        {
            httpReg: /\/product\/(\d+)(.html)?/i,
            http2Data: (link, httpReg) => {
                const gpid = httpReg.exec(link)[1];
                const query = common_1.getUrlQuery(link);
                const { name = "ezbuy" } = query, other = __rest(query, ["name"]);
                return Object.assign(Object.assign({}, other), { uri: gpid, previewinfo: JSON.stringify({
                        name,
                    }) });
            },
            data2Http: (query) => {
                const queryObj = {
                    purchasemode: query.type === "shangou" ? "flashdeal" : query.type,
                };
                const uri = query.uri;
                const identifier = common_1.allNumberRegExp.test(uri) ? `${uri}.html` : encodeURIComponent(uri);
                return withEZSPM(`/product/${identifier}${common_1.convertQueryToString(queryObj)}`, query);
            },
        },
    ],
    [
        types_1.PageType.Shop,
        {
            data2Http: (query) => {
                const { storename, type, categoryid, keywords } = query;
                let url = "";
                if (type === "search" || type === "category") {
                    url = `/shop/${storename}/products?${type === "search" ? "keywords=" + keywords : "categoryId=" + categoryid}`;
                }
                else {
                    url = `/shop/${storename}`;
                }
                return withEZSPM(url, query);
            },
        },
    ],
    [
        types_1.PageType.FriendsDealEvent,
        {
            data2Http: (query) => {
                const { producturl, eventid } = query;
                return withEZSPM(`/friendsdeal/event?eventid=${eventid}&producturl=${producturl}`, query);
            },
        },
    ],
    [
        types_1.PageType.FriendsDealGroup,
        {
            data2Http: (query) => {
                const { groupid } = query;
                return withEZSPM(`/friendsdeal/group?groupid=${groupid}`, query);
            },
        },
    ],
    [
        types_1.PageType.Promotion,
        {
            data2Http: (query) => {
                return withEZSPM(`/promotionlist/addon.html?activityId=${query.id}`, query);
            },
        },
    ],
    [
        types_1.PageType.Surf,
        {
            data2Http: () => "/surf.html",
        },
    ],
    [
        types_1.PageType.Login,
        {
            data2Http: (query) => {
                const queryObj = {
                    demographics: query.demographics,
                };
                return withEZSPM(`/login${common_1.convertQueryToString(queryObj)}`, query);
            },
        },
    ],
    [
        types_1.PageType.Register,
        {
            data2Http: (query) => {
                const queryObj = {
                    demographics: query.demographics,
                };
                return withEZSPM(`/register${common_1.convertQueryToString(queryObj)}`, query);
            },
        },
    ],
];
exports.TypeMap = new Map(items);
